import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { PUBLIC_URL } from "../../constants";

/**
 * List view dragging preview component
 * @param {number} count : selecteItems length
 * @param {object} selectedItem : first item
 */
const ListDragPreview = React.forwardRef(({
    count,
    selectedItem
}, ref) => {
    const mediaTypeLowerCase = selectedItem.mediaType && selectedItem.mediaType.toLowerCase();

    return (
        // TODO : dropping-item error 케이스 발생 시, 추가
        ReactDOM.createPortal(
            <div ref={ref}
                className="dropping-item"
                style={{
                    transform: 'translateX(-9999px)',
                    zIndex: 1,
                    opacity: 1
                }}>
                <div className="list-content">
                    <div className={`list-thumbnail`}>
                        {{
                            IMAGE : (
                                <span className={`type type-${mediaTypeLowerCase}`}>
                                    <span>
                                        <img src={selectedItem.accessUrls &&
                                            selectedItem.accessUrls[0] || `${PUBLIC_URL}/images/thumbnail_no_image_s.png`}
                                        onError={e => {
                                            e.target.src = `${PUBLIC_URL}/images/thumbnail_default_image.png`;
                                        }}/>
                                    </span>
                                </span>
                            ),
                            VIDEO : (
                                <span className={`type type-${mediaTypeLowerCase}`}>
                                    <span>
                                        <img
                                            src={selectedItem.thumbnails &&
                                                    selectedItem.thumbnails[0] &&
                                                    selectedItem.thumbnails[0].accessUrl}
                                            onError={e => {
                                                e.target.hidden = true;
                                            }}
                                        />
                                    </span>
                                </span>
                            ),
                            AUDIO : (
                                <span className={`type type-${mediaTypeLowerCase}`}>
                                    <span>
                                        <i className={`sprite sprite-type-${mediaTypeLowerCase}`}></i>
                                    </span>
                                </span>
                            ),
                            TEXT : (
                                <span className={`type type-${mediaTypeLowerCase}`}>
                                    <span>
                                        <i className={`sprite sprite-type-${mediaTypeLowerCase}`}></i>
                                    </span>
                                </span>
                            ),
                            CAPTION : (
                                <span className={`type type-${mediaTypeLowerCase}`}>
                                    <span>
                                        <i className={`sprite sprite-type-${mediaTypeLowerCase}`}></i>
                                    </span>
                                </span>
                            ),
                            FILE : (
                                <span className={`type type-${mediaTypeLowerCase}`}>
                                    <span>
                                        <i className={`sprite sprite-type-${mediaTypeLowerCase}`}></i>
                                    </span>
                                </span>
                            )
                        }[selectedItem.mediaType]}
                    </div>
                    <div className={"list-title"}>
                        <span className={"text-ellipsis"}>{selectedItem.name}</span>
                        <small className="text-cancel text-smaller">{selectedItem.id}</small>
                    </div>
                    <div className={"list-icons"}>
                        <div>
                            {selectedItem.isConnected ? <i className="sprite sprite-reference-linked" /> : ''}
                        </div>
                        <div>
                            {selectedItem.hasDubbing ? <i className={"sprite sprite-dubbing"} /> : ''}
                            {selectedItem.encryptions &&
                                selectedItem.encryptions.includes('DRM') ? <i className={"sprite sprite-drm"} /> : ''}
                            {selectedItem.isAnalyzed ? <i className={"sprite sprite-ai-video"} /> : ''}
                        </div>
                    </div>
                </div>
                <div className="dropping-item-status">{count}</div>
            </div>,
            document.body
        )
    )
});

ListDragPreview.propsType = {
    count: PropTypes.number,
    selectedItem: PropTypes.object
}

export default ListDragPreview;